var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioRecorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 175C58.7776 175 25.2002 141.423 25.2002 100C25.2002 58.5774 58.7776 25 100.2 25C141.623 25 175.2 58.5774 175.2 100C175.2 141.423 141.623 175 100.2 175Z",
    fill: "url(#paint0_linear_26801_2935)",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26801_2935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 25,
    width: 151,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 175C58.7776 175 25.2002 141.423 25.2002 100C25.2002 58.5774 58.7776 25 100.2 25C141.623 25 175.2 58.5774 175.2 100C175.2 141.423 141.623 175 100.2 175Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26801_2935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.118 107.252C127.815 107.252 126.761 108.306 126.761 109.609V117.174C126.761 124.605 123.708 131.37 118.81 136.277C113.902 141.182 107.138 144.226 99.6971 144.226C92.2659 144.226 85.5013 141.185 80.5938 136.277C75.6863 131.37 72.642 124.605 72.642 117.174V109.609C72.642 108.306 71.5886 107.252 70.2856 107.252C68.9826 107.252 67.9202 108.306 67.9202 109.609V117.174C67.9202 125.908 71.4973 133.851 77.2572 139.611C81.808 144.167 87.7319 147.353 94.333 148.486V170.264H80.4631C76.5755 170.264 73.3911 173.449 73.3911 177.337V184.409H126.01V177.337C126.01 173.449 122.831 170.264 118.938 170.264H105.077V148.484C111.674 147.349 117.59 144.164 122.143 139.611C127.903 133.851 131.474 125.911 131.474 117.174V109.609C131.474 108.306 130.421 107.252 129.118 107.252Z",
    fill: "url(#paint1_linear_26801_2935)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7003 64.2235C110.678 64.2235 119.656 73.2013 119.656 84.1793V117.177C119.656 128.146 110.678 137.124 99.7003 137.124C88.7315 137.124 79.7537 128.146 79.7537 117.177V84.1793C79.7537 73.2013 88.7315 64.2235 99.7003 64.2235Z",
    fill: "url(#paint2_linear_26801_2935)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.656 90.5815V95.2973H108.629C107.326 95.2973 106.264 94.2439 106.264 92.9409C106.264 91.6379 107.326 90.5846 108.629 90.5846H119.656V90.5815ZM119.656 98.3142V103.03H108.629C107.326 103.03 106.264 101.977 106.264 100.674C106.264 99.3706 107.326 98.3172 108.629 98.3172H119.656V98.3142ZM119.656 106.05V110.775H108.629C107.326 110.775 106.264 109.712 106.264 108.409C106.264 107.112 107.326 106.053 108.629 106.053H119.656V106.05Z",
    fill: "#6183E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8574 58.2327C27.6441 57.3191 25.9097 57.5761 25.0069 58.8001C20.589 64.7667 17.0883 71.4506 14.7295 78.6234C12.4349 85.5642 11.2002 92.9796 11.2002 100.673C11.2002 108.374 12.4349 115.783 14.7259 122.723C17.0883 129.907 20.5855 136.58 25.0069 142.547C25.9062 143.771 27.6405 144.028 28.8574 143.125C30.0814 142.215 30.3383 140.488 29.4355 139.264C25.378 133.786 22.1628 127.63 19.9788 120.996C17.8734 114.609 16.735 107.778 16.735 100.673C16.735 93.5684 17.8734 86.7382 19.9788 80.3505C22.1628 73.7166 25.378 67.5609 29.4355 62.0831C30.3383 60.8698 30.0814 59.1355 28.8574 58.2327ZM42.2038 68.0997C40.9905 67.1862 39.2562 67.4431 38.3533 68.6671C34.9739 73.2349 32.2975 78.3379 30.4954 83.8227C28.7432 89.1327 27.8011 94.796 27.8011 100.677C27.8011 106.554 28.7397 112.228 30.4954 117.531C32.2975 123.016 34.9739 128.123 38.3533 132.68C39.2526 133.904 40.9869 134.161 42.2038 133.258C43.4278 132.348 43.6847 130.621 42.7819 129.397C39.7629 125.328 37.372 120.743 35.7447 115.804C34.1781 111.051 33.3253 105.966 33.3253 100.673C33.3253 95.392 34.1781 90.3068 35.7447 85.5535C37.372 80.6039 39.7629 76.0255 42.7819 71.9502C43.6847 70.7262 43.4278 69.0026 42.2038 68.0997ZM51.7033 78.5341C52.6061 77.3101 54.3404 77.0532 55.5537 77.956C56.7778 78.866 57.0347 80.5932 56.1318 81.8172C54.1513 84.4829 52.5847 87.4912 51.5177 90.7457C50.49 93.861 49.9297 97.2048 49.9297 100.673C49.9297 104.153 50.49 107.486 51.5177 110.612C52.5847 113.856 54.1549 116.864 56.1318 119.54C57.0347 120.757 56.7778 122.491 55.5537 123.391C54.3369 124.301 52.6026 124.037 51.7033 122.823C49.3623 119.658 47.5102 116.129 46.2648 112.339C45.0479 108.663 44.402 104.745 44.402 100.677C44.402 96.6088 45.0479 92.6906 46.2648 89.015C47.5067 85.2287 49.3587 81.6923 51.7033 78.5341ZM170.539 58.2327C169.315 59.132 169.062 60.8698 169.972 62.0831C174.029 67.5609 177.245 73.713 179.429 80.3505C181.534 86.7382 182.672 93.5684 182.672 100.673C182.672 107.778 181.534 114.609 179.429 120.996C177.245 127.63 174.029 133.786 169.972 139.264C169.058 140.488 169.315 142.215 170.539 143.125C171.763 144.028 173.491 143.771 174.401 142.547C178.822 136.58 182.308 129.907 184.682 122.723C186.965 115.786 188.2 108.374 188.2 100.673C188.2 92.9796 186.965 85.5606 184.682 78.6234C182.308 71.4506 178.822 64.7667 174.401 58.8001C173.491 57.5761 171.763 57.3227 170.539 58.2327ZM157.193 68.0997C155.969 68.999 155.716 70.7262 156.626 71.9502C159.634 76.0255 162.035 80.6039 163.663 85.5463C165.233 90.2996 166.075 95.3848 166.075 100.666C166.075 105.958 165.229 111.044 163.663 115.797C162.035 120.736 159.634 125.321 156.626 129.389C155.712 130.614 155.969 132.341 157.193 133.251C158.417 134.154 160.144 133.897 161.054 132.673C164.434 128.116 167.099 123.012 168.912 117.524C170.657 112.225 171.606 106.551 171.606 100.67C171.606 94.7924 170.657 89.1256 168.912 83.8156C167.099 78.3379 164.434 73.2349 161.054 68.6671C160.144 67.4431 158.417 67.1897 157.193 68.0997ZM143.279 81.8172C142.369 80.5932 142.622 78.866 143.846 77.956C145.07 77.0532 146.798 77.3101 147.708 78.5341C150.041 81.6887 151.894 85.2287 153.146 89.0114C154.352 92.687 155.009 96.6053 155.009 100.673C155.009 104.742 154.352 108.66 153.146 112.335C151.89 116.129 150.038 119.654 147.708 122.82C146.798 124.037 145.07 124.301 143.846 123.387C142.622 122.484 142.366 120.75 143.279 119.537C145.249 116.86 146.826 113.852 147.893 110.608C148.921 107.482 149.481 104.149 149.481 100.67C149.481 97.2012 148.921 93.8575 147.893 90.7421C146.826 87.4912 145.249 84.4829 143.279 81.8172Z",
    fill: "url(#paint3_radial_26801_2935)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7537 90.5815V95.2973H90.7803C92.0833 95.2973 93.1366 94.2439 93.1366 92.9409C93.1366 91.6379 92.0833 90.5846 90.7803 90.5846H79.7537V90.5815ZM79.7537 98.3142V103.03H90.7803C92.0833 103.03 93.1366 101.977 93.1366 100.674C93.1366 99.3706 92.0833 98.3172 90.7803 98.3172H79.7537V98.3142ZM79.7537 106.05V110.775H90.7803C92.0833 110.775 93.1366 109.712 93.1366 108.409C93.1366 107.112 92.0833 106.053 90.7803 106.053H79.7537V106.05Z",
    fill: "#6183E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7001 64.2235C100.452 64.2235 101.189 64.2722 101.916 64.3483C91.9766 65.4595 84.1739 73.9533 84.1739 84.1793V90.5815H79.7505V84.1793C79.7535 73.2013 88.7313 64.2235 99.7001 64.2235ZM84.1739 95.2972V98.3142H79.7505V95.2972H84.1739ZM84.1739 103.03V106.047H79.7505V103.03H84.1739ZM84.1739 110.772V117.177C84.1739 127.4 91.9736 135.888 101.913 136.999C101.186 137.081 100.449 137.124 99.6971 137.124C88.7283 137.124 79.7505 128.146 79.7505 117.177V110.772H84.1739Z",
    fill: "url(#paint4_linear_26801_2935)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_2935",
    x1: 25.2002,
    y1: 36.7188,
    x2: 168.169,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_2935",
    x1: 67.9202,
    y1: 113.28,
    x2: 138.778,
    y2: 166.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_2935",
    x1: 99.7048,
    y1: 64.2235,
    x2: 99.7048,
    y2: 137.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_26801_2935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.2002 101) scale(89 105.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906526,
    stopColor: "#F3D527"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_2935",
    x1: 79.7505,
    y1: 69.9188,
    x2: 115.538,
    y2: 79.7895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioRecorder);
export default __webpack_public_path__ + "static/media/Audio-Recorder.65393c4b17db2f7e67223062f9370646.svg";
export { ForwardRef as ReactComponent };